import { Typography } from '@/components/Typography';
import * as PM from '@/messages/payment';

import { useOrderDetailsContext } from '../OrderDetailsContext';
import { ReturnHistoryOriginalOrderLink } from './ReturnHistoryOriginalOrderLink';

import * as S from '../OrderDetailsView.styles';

export function OrderDetailsHeaderSection() {
  const ctx = useOrderDetailsContext();
  const title =
    ctx.type === 'RETURNHISTORY'
      ? ctx.formatMessage(PM.paymentMessages.returnDetails)
      : ctx.deliveryMethodName;
  const textAlign = ctx.isMobileView ? 'center' : 'left';

  return (
    <S.OrderDetailHeader>
      <Typography
        data-test-id='OrderDetailsViewDeliveryMethodName'
        fontWeight='bold'
        marginBottom={2}
        scale='h4'
        textAlign={textAlign}
        textTransform='uppercase'
      >
        {title}
      </Typography>
      <ReturnHistoryOriginalOrderLink
        formatMessage={ctx.formatMessage}
        guestSession={ctx.guestSession}
        orderId={ctx.order.id}
        paths={ctx.paths}
        push={ctx.push}
        type={ctx.type}
      />
    </S.OrderDetailHeader>
  );
}
